import { CONSTANTS } from '../../model/custom-adf-model';
export const presetsDefaultModel = {
  '-trashcan-': [
    {
      key: CONSTANTS.THUMB_NAIL,
      type: 'image',
      srTitle: CONSTANTS.THUMBNAIL_LAYOUT,
      sortable: false,
    },
    {
      key: 'name',
      type: 'text',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_NAME,
      cssClass: CONSTANTS.CSS_CLASS,
      sortable: true,
    },
    {
      key: 'path',
      type: 'location',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_LOCATION,
      sortable: true,
    },
    {
      key: CONSTANTS.SIZE_BYTES,
      type: 'fileSize',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_SIZE,
      sortable: true,
    },
    {
      key: 'archivedAt',
      type: 'date',
      title: 'ADF-DOCUMENT-LIST.LAYOUT.DELETED_ON',
      format: 'timeAgo',
      sortable: true,
    },
    {
      key: 'archivedByUser.displayName',
      type: 'text',
      title: 'ADF-DOCUMENT-LIST.LAYOUT.DELETED_BY',
      sortable: true,
    },
  ],
  '-sites-': [
    {
      key: CONSTANTS.THUMB_NAIL,
      type: 'image',
      srTitle: CONSTANTS.THUMBNAIL_LAYOUT,
      sortable: false,
    },
    {
      key: 'title',
      type: 'text',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_NAME,
      cssClass: CONSTANTS.CSS_CLASS,
      sortable: true,
    },
    {
      key: 'visibility',
      type: 'text',
      title: 'ADF-DOCUMENT-LIST.LAYOUT.STATUS',
      sortable: true,
    },
  ],
  '-mysites-': [
    {
      key: CONSTANTS.THUMB_NAIL,
      type: 'image',
      srTitle: CONSTANTS.THUMBNAIL_LAYOUT,
      sortable: false,
    },
    {
      key: 'title',
      type: 'text',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_NAME,
      cssClass: CONSTANTS.CSS_CLASS,
      sortable: true,
    },
    {
      key: 'visibility',
      type: 'text',
      title: 'ADF-DOCUMENT-LIST.LAYOUT.STATUS',
      sortable: true,
    },
  ],
  '-favorites-': [
    {
      key: CONSTANTS.THUMB_NAIL,
      type: 'image',
      srTitle: CONSTANTS.THUMBNAIL_LAYOUT,
      sortable: false,
    },
    {
      key: 'name',
      type: 'text',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_NAME,
      cssClass: CONSTANTS.CSS_CLASS,
      sortable: true,
    },
    {
      key: 'path',
      type: 'location',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_LOCATION,
      sortable: true,
    },
    {
      key: CONSTANTS.SIZE_BYTES,
      type: 'fileSize',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_SIZE,
      sortable: true,
    },
    {
      key: 'modifiedAt',
      type: 'date',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_MODIFIED,
      format: 'timeAgo',
      sortable: true,
    },
    {
      key: CONSTANTS.USER_NAME,
      type: 'text',
      title: CONSTANTS.DOCUMENT_LIST_MODIFIED_BY,
      sortable: true,
    },
  ],
  '-recent-': [
    {
      key: CONSTANTS.THUMB_NAIL,
      type: 'image',
      srTitle: CONSTANTS.THUMBNAIL_LAYOUT,
      sortable: false,
    },
    {
      key: 'name',
      type: 'text',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_NAME,
      cssClass: CONSTANTS.CSS_CLASS,
      sortable: true,
    },
    {
      key: 'path',
      type: 'location',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_LOCATION,
      cssClass: 'ellipsis-cell',
      sortable: true,
    },
    {
      key: CONSTANTS.SIZE_BYTES,
      type: 'fileSize',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_SIZE,
      sortable: true,
    },
    {
      key: 'modifiedAt',
      type: 'date',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_MODIFIED,
      format: 'timeAgo',
      sortable: true,
    },
  ],
  '-sharedlinks-': [
    {
      key: CONSTANTS.THUMB_NAIL,
      type: 'image',
      srTitle: CONSTANTS.THUMBNAIL_LAYOUT,
      sortable: false,
    },
    {
      key: 'name',
      type: 'text',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_NAME,
      cssClass: CONSTANTS.CSS_CLASS,
      sortable: true,
    },
    {
      key: 'path',
      type: 'location',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_LOCATION,
      cssClass: 'ellipsis-cell',
      sortable: true,
    },
    {
      key: CONSTANTS.SIZE_BYTES,
      type: 'fileSize',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_SIZE,
      sortable: true,
    },
    {
      key: 'modifiedAt',
      type: 'date',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_MODIFIED,
      format: 'timeAgo',
      sortable: true,
    },
    {
      key: CONSTANTS.USER_NAME,
      type: 'text',
      title: CONSTANTS.DOCUMENT_LIST_MODIFIED_BY,
      sortable: true,
    },
    {
      key: 'sharedByUser.displayName',
      type: 'text',
      title: 'ADF-DOCUMENT-LIST.LAYOUT.SHARED_BY',
      sortable: true,
    },
  ],
  default: [
    {
      key: CONSTANTS.THUMB_NAIL,
      type: 'image',
      srTitle: CONSTANTS.THUMBNAIL_LAYOUT,
      sortable: false,
    },
    {
      key: 'name',
      type: 'text',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_NAME,
      cssClass: CONSTANTS.CSS_CLASS,
      sortable: true,
    },
    {
      key: CONSTANTS.SIZE_BYTES,
      type: 'fileSize',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_SIZE,
      sortable: true,
    },
    {
      key: 'modifiedAt',
      type: 'date',
      title: CONSTANTS.DOCUMENT_LIST_LAYOUT_MODIFIED,
      format: 'timeAgo',
      sortable: true,
    },
    {
      key: CONSTANTS.USER_NAME,
      type: 'text',
      title: CONSTANTS.DOCUMENT_LIST_MODIFIED_BY,
      sortable: true,
    },
  ],
};
